export const defaultTheme = {
  color: {
    primary: '#ff8a3c',
    secondary: '#ff4081',
    gray: '#666',
  },

  size: {
    rap: '1.2rem',
    borderRadius: '.4rem',
  },

  font: {
    h1: '3rem',
    h2: '2.5rem',
    h3: '2rem',
    h4: '1.3rem',
    h5: '1em',
    h6: '0.8rem',
  },
};
